import React, { useState, useEffect, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import {
	TableCell,
	TableRow,
	Card,
	CardHeader,
	CardContent,
  Button,
  List,
  ListItem,
  Popper, FormControl, InputLabel, Select, MenuItem, Box, LinearProgress, Input, ListItemText, Checkbox, IconButton, Popover, Chip, TextField, Typography
} from '@material-ui/core';
import { useQuery, useMutation, useApolloClient } from '@apollo/client';
import _ from 'lodash';
import SearchBar from 'components/Search/SearchBar';
import { Link, useHistory, NavLink } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';
import { VirtualizedTable } from 'components/Table/VirtualizedTable';
import {TableCellRenderer, Table} from 'react-virtualized';
import clsx from 'clsx';
import {LeaderboardFeedVars,LeaderboardFeedQuery,LeaderboardFeedData} from '@pvplevelup/core/dist/queries/leaderboard/leaderboardFeed'
import { Waypoint } from 'react-waypoint';
import { classImages } from 'utilities/ClassImages';
import { AocClasses } from '@pvplevelup/core/dist/interfaces/ICharacter';
import {LookupCharactersData,LookupCharactersQuery,LookupCharactersVars} from '@pvplevelup/core/dist/queries/character/lookupCharacters';
import {LeaderboardSeasonsQuery,LeaderboardSeasonsData} from '@pvplevelup/core/dist/queries/leaderboard/seasons';
import { useMountedState } from 'components/useMountedState';
import { rankImages } from 'utilities/rankImages';
import { normalize } from 'utilities/normalize';
import { TeamColors } from 'utilities/team_colors';
import { getPlayerPerformance } from '@pvplevelup/core/dist/interfaces/Game/IGame';
import { getRatingComponent } from 'views/PvP/game/GameScore';
import moment from 'moment';
import PlaceHolderImage from 'assets/images/icons/no_profile.jpg';
import { CalendarToday, EmojiEvents } from '@material-ui/icons';
import { PageHeader, PageEmpty, PAGE_KIT, usePageStyles } from 'components/Page/PageKit';
import { DateRangePicker } from 'react-date-range';
import { ISeason } from '@pvplevelup/core/dist/interfaces/ISeason';

const useStyles = makeStyles((theme) => {
	return {
		title: {
			paddingTop: '8px'
    },
		cardCategoryWhite: {
			'&,& a,& a:hover,& a:focus': {
				color: 'rgba(255,255,255,.62)',
				margin: '0',
				fontSize: '14px',
				marginTop: '0',
				marginBottom: '0'
			},
			'& a,& a:hover,& a:focus': {
				color: '#FFFFFF'
			}
		},
		cardTitleWhite: {
			color: '#FFFFFF',
			marginTop: '0px',
			minHeight: 'auto',
			fontWeight: 'bold',
			fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
			marginBottom: '3px',
			textDecoration: 'none',
			'& small': {
				color: '#777',
				fontSize: '65%',
				fontWeight: '400',
				lineHeight: '1'
			}
		},
		cardHeader: {
			padding: '0.75rem 1.25rem',
			marginBottom: '0',
			borderBottom: 'none',
			background: theme.palette.primary.main,
			zIndex: 3
    },
    buttonProgress: {
      color: theme.palette.primary.main,
      position: 'absolute',
      top: '50%',
      left: '50%',
      marginTop: -12,
      marginLeft: -12,
    },
    classGrid: {
      display: "grid",
      gridTemplateColumns: "repeat(14, auto)",
      alignItems:'end',
      gridGap: '1em'
    },
    classIcon: {
      width:'3em',
      cursor:'pointer'
    },
    characterContainer: {
      marginTop: '1em',
      minWidth:'20vw',
      height:'25em',
      overflow:'auto',
    },
    link: {
      textDecoration: "none",
      color: "#6cbbff",
      "&:hover,&:focus": {
        color: "#FFF"
      }
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 100,
    },
    progress:{
      height:10,
    },
    blueBarRoot:{
      height:10
    },
    blueBarBar:{
      background:TeamColors[0],
    },
    // filter row: every control is PAGE_KIT.controlHeight tall, dark and rounded like PageSearch
    filter: {
      minWidth: 130,
    },
    filterWide: {
      minWidth: 220,
      maxWidth: 360,
    },
    filterField: {
      '& .MuiOutlinedInput-root': {
        height: PAGE_KIT.controlHeight,
        borderRadius: 10,
        fontSize: '0.9rem',
        background: 'rgba(0, 0, 0, 0.3)',
        transition: 'box-shadow 0.15s',
        '&:hover .MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(255, 255, 255, 0.25)',
        },
        '&.Mui-focused': {
          boxShadow: '0 0 0 3px rgba(66, 165, 245, 0.15)',
        },
        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
          borderColor: PAGE_KIT.accent,
          borderWidth: 1,
        },
      },
      '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'rgba(255, 255, 255, 0.1)',
      },
      // regular weight: the gap cut into the outline is measured for the theme's label, so a bolder one overruns it
      '& .MuiInputLabel-outlined': {
        color: PAGE_KIT.muted,
      },
      '& .MuiInputLabel-outlined.Mui-focused': {
        color: PAGE_KIT.accent,
      },
      '& .MuiSelect-icon': {
        color: PAGE_KIT.muted,
      },
    },
    selectedClasses: {
      display: 'inline-grid',
      gridAutoFlow: 'column',
      gridGap: 3,
      alignItems: 'center',
      verticalAlign: 'middle',
      '& img': {
        width: 18,
        height: 18,
        display: 'block',
      },
    },
    classOption: {
      width: 24,
      height: 24,
      marginRight: 8,
    },
    dateButton: {
      height: PAGE_KIT.controlHeight,
      padding: '0 14px',
      borderRadius: 10,
      textTransform: 'none',
      fontWeight: 600,
      fontSize: '0.9rem',
      whiteSpace: 'nowrap',
      color: 'rgba(255, 255, 255, 0.85)',
      background: 'rgba(0, 0, 0, 0.3)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
      '&:hover': {
        background: 'rgba(255, 255, 255, 0.06)',
        borderColor: 'rgba(255, 255, 255, 0.25)',
      },
      '& .MuiButton-startIcon': {
        color: PAGE_KIT.muted,
      },
    },
    /** a date range is set */
    dateActive: {
      color: '#90caf9',
      borderColor: 'rgba(66, 165, 245, 0.45)',
      background: 'rgba(66, 165, 245, 0.08)',
      '& .MuiButton-startIcon': {
        color: PAGE_KIT.accent,
      },
    },
    resetButton: {
      height: PAGE_KIT.controlHeight,
      padding: '0 12px',
      borderRadius: 10,
      textTransform: 'none',
      fontWeight: 700,
      color: '#90caf9',
      '&.Mui-disabled': {
        color: PAGE_KIT.faint,
      },
    },
    count: {
      padding: '7px 12px',
      borderRadius: 10,
      fontSize: '0.82rem',
      whiteSpace: 'nowrap',
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.08)',
      '& strong': {
        color: '#fff',
        fontWeight: 800,
        fontVariantNumeric: 'tabular-nums',
      },
    },
    // table
    table: {
      '& .MuiTableCell-body': {
        fontSize: '0.88rem',
        fontVariantNumeric: 'tabular-nums',
      },
    },
    rank: {
      display: 'grid',
      placeItems: 'center',
      minWidth: 30,
      height: 30,
      padding: '0 6px',
      boxSizing: 'border-box',
      borderRadius: 9,
      fontSize: '0.82rem',
      fontWeight: 800,
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.04)',
      border: '1px solid rgba(255, 255, 255, 0.07)',
    },
    player: {
      display: 'grid',
      gridTemplateColumns: '36px minmax(0, 1fr)',
      gridGap: 10,
      alignItems: 'center',
      width: '100%',
      minWidth: 0,
    },
    playerIcon: {
      width: 36,
      height: 36,
      padding: 3,
      boxSizing: 'border-box',
      borderRadius: 10,
      objectFit: 'cover',
      background: 'rgba(255, 255, 255, 0.05)',
      border: '1px solid rgba(255, 255, 255, 0.1)',
    },
    playerAvatar: {
      padding: 0,
      borderRadius: '50%',
    },
    playerName: {
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.92rem',
    },
    playerSub: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      fontSize: '0.75rem',
      color: PAGE_KIT.faint,
    },
    mmr: {
      fontSize: '1rem',
      fontWeight: 800,
      letterSpacing: '-0.01em',
      color: '#fff',
    },
    perf: {
      fontWeight: 800,
    },
    /** best / worst values: secondary to the current ones */
    dim: {
      color: PAGE_KIT.muted,
    },
    winRate: {
      width: '100%',
      paddingRight: 16,
    },
    winTop: {
      display: 'grid',
      gridTemplateColumns: 'auto minmax(0, 1fr)',
      gridGap: 8,
      alignItems: 'baseline',
    },
    winPct: {
      fontWeight: 800,
    },
    winRecord: {
      justifySelf: 'end',
      fontSize: '0.75rem',
      color: PAGE_KIT.faint,
    },
    winTrack: {
      marginTop: 5,
      height: 4,
      borderRadius: 2,
      background: 'rgba(255, 255, 255, 0.07)',
      overflow: 'hidden',
    },
    winFill: {
      height: '100%',
      borderRadius: 2,
    },
    change: {
      padding: '2px 8px',
      borderRadius: 8,
      fontSize: '0.8rem',
      fontWeight: 700,
      color: PAGE_KIT.muted,
      background: 'rgba(255, 255, 255, 0.05)',
    }
	};
});

/** gold, silver and bronze medals for the top three */
const RANK_STYLES: Record<number, React.CSSProperties> = {
  1: {background: 'linear-gradient(135deg, #fbe08a, #c9a227)', color: '#2b2200', border: 0, boxShadow: '0 0 14px rgba(249, 217, 118, 0.35)'},
  2: {background: 'linear-gradient(135deg, #eef1f5, #9aa3ad)', color: '#1f2328', border: 0, boxShadow: '0 0 12px rgba(220, 225, 232, 0.22)'},
  3: {background: 'linear-gradient(135deg, #e9b07a, #a8652e)', color: '#2a1606', border: 0, boxShadow: '0 0 12px rgba(227, 167, 111, 0.25)'},
};

/** green for gains, red for losses */
const changeStyle = (change: number): React.CSSProperties | undefined => change > 0
  ? {color: '#66bb6a', background: 'rgba(102, 187, 106, 0.12)'}
  : change < 0 ? {color: '#ef5350', background: 'rgba(239, 83, 80, 0.12)'} : undefined;

/** red under 40%, amber around 50%, green over 60% */
const winRateColor = (rate: number) => rate >= 60 ? '#43a047' : rate >= 50 ? '#7cb342' : rate >= 40 ? '#fb8c00' : '#e53935';

interface Props {}

export const Leaderboard: React.FC<Props> = (props) => {
	const history = useHistory();
  const classes = useStyles();
  const page = usePageStyles();
  const apolloClient = useApolloClient();
  const isMounted = useMountedState();

  const [startDate, setStartDate] = useState<string | null>(null);
  const [endDate, setEndDate] = useState<string | null>(null);
  const [server,setServer] = useState<string>("Fury");
  const [season,setSeason] = useState<number>(1);
  const [seasons,setSeasons] = useState<ISeason[]>([]);
  const [ranked,setRanked] = useState<boolean>(true);
  const [byUser,setByUser] = useState<boolean>(false);
  const [ name, setName ] = useState('');
  const [ showCharacterSearch, setShowCharacterSearch ] = useState(false);
  const [ character, setCharacter ] = useState('');
	const [ typing, setTyping ] = useState(false);
  const [ typingTimeout, setTypingTimeout ] = useState<NodeJS.Timeout | undefined>();
  const [ selectedClasses, setSelectedClasses ] = useState<string[]>([]);
  const [ useAssassin, setUseAssassin] = useState(false);
  const [ useBarbarian, setUseBarbarian] = useState(false);
  const [ useRanger, setUseRanger] = useState(false);
  const [ usePriestofMitra, setUsePriestofMitra] = useState(false);
  const [ useBearshaman, setUseBearshaman] = useState(false);
  const [ useTempestofSet, setUseTempestofSet] = useState(false);
  const [ useGuardian, setUseGuardian] = useState(false);
  const [ useConqueror, setUseConqueror] = useState(false);
  const [ useDarkTemplar, setUseDarkTemplar] = useState(false);
  const [ useDemonologist, setUseDemonologist] = useState(false);
  const [ useHeraldofXotli, setUseHeraldofXotli] = useState(false);
  const [ useNecromancer, setUseNecromancer] = useState(false);
  const [ reseting, setReseting ] = useState(false);
  const [ shouldRefetch, setShouldRefetch ] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const scrollableAncestor = useRef(null);
  const [ignoreNextPrevious, setIgnoreNextPrevious] = useState(false);
  const gridRef = useRef<Table>(null);


  const [newLength, setNewLength] = useState<number | null>(null);
  const [nextCursor, setNextCursor] = useState<string | undefined>("");
  const [hasNextCursor, setHasNextCursor] = useState<boolean | undefined>(false);
  const [previousCursor, setPreviousCursor] = useState<string | undefined>("");
  const [hasPreviousCursor, setHasPreviousCursor] = useState<boolean | undefined>(false);
  const [isInitial, setIsInitial] = useState(true);
  const [scrollToIndex, setScrollToIndex] = useState<number | undefined>(undefined);
  const [startingIndex, setStartingIndex] = useState(0);

	const { refetch, data, loading, fetchMore } = useQuery<LeaderboardFeedData, LeaderboardFeedVars>(LeaderboardFeedQuery, {
    variables: {server:server,season:season,ranked:ranked,byUser:byUser,startDate:startDate,endDate:endDate,next:"",previous:""}
  });

  

  const { fetchMore: lookupFetchMore, refetch: lookupRefetch, data: lookupData, error, loading: lookupLoading } = useQuery<LookupCharactersData,LookupCharactersVars>(
    LookupCharactersQuery,
    { variables: {next:"",character:""},fetchPolicy:'cache-and-network' }
  );

  useEffect(()=>{
    if(isMounted()){
      apolloClient.query<LeaderboardSeasonsData>({query:LeaderboardSeasonsQuery}).then((res)=>{
        if(res.data){
          if(res.data.currentSeason){
            setSeason(res.data.currentSeason.season);
            setShouldRefetch(true);
          }
          setSeasons(res.data.seasons || []);
        }
      })
    }
  },[])

  const getClasses = () => {
    let classes:string[] = [];
    if(useAssassin)
      classes.push(AocClasses.Assassin);
    if(useBarbarian)
      classes.push(AocClasses.Barbarian);
    if(useRanger)
      classes.push(AocClasses.Ranger);
    if(usePriestofMitra)
      classes.push(AocClasses.PriestofMitra);
    if(useBearshaman)
      classes.push(AocClasses.BearShaman);
    if(useTempestofSet)
      classes.push(AocClasses.TempestofSet);
    if(useGuardian)
      classes.push(AocClasses.Guardian);
    if(useDarkTemplar)
      classes.push(AocClasses.DarkTemplar);
    if(useConqueror)
      classes.push(AocClasses.Conqueror);
    if(useDemonologist)
      classes.push(AocClasses.Demonologist);
    if(useHeraldofXotli)
      classes.push(AocClasses.HeraldofXotli);
    if(useNecromancer)
      classes.push(AocClasses.Necromancer);

    return classes;
  }

  const resetClasses = () => {
    setReseting(true);
    setStartDate(null);
    setEndDate(null);
    setSelectedClasses([]);
    setNextCursor("");
    setPreviousCursor("");
    setHasPreviousCursor(false);
    setHasNextCursor(true);
    setCharacter("");
    setShouldRefetch(true);
    setReseting(false);
  }
	

	const onChangeName = (newName: string) => {
		if (typingTimeout) clearTimeout(typingTimeout);

		setName(newName);
		setTyping(true);
		setTypingTimeout(
			setTimeout(() => {
				lookupRefetch({ next: "", character: newName });
				setTyping(false);
			}, 600)
		);
  };

  /*const onCharacterSelect = async (character_id: string) => {
    setCharacter(character_id);
    setIgnoreNextPrevious(true);
    setNewLength(0);
    setScrollToIndex(0);
    let refetchResult = await refetch({previous:"",next:"",character:character_id,classes:selectedClasses});
    if(refetchResult.data){
      setIsInitial(false);
      setPreviousCursor(refetchResult.data.leaderboardFeed.previous);
      setHasPreviousCursor(refetchResult.data.leaderboardFeed.previous != null);
      setNextCursor(refetchResult.data.leaderboardFeed.next);
      setHasNextCursor(refetchResult.data.leaderboardFeed.hasNext)
    }
  }*/

  /*const fetchMoreCharacters = ()=>{
    if(lookupData?.lookupCharacters.hasNext){
      lookupFetchMore({
        variables:{character:name,next:lookupData?.lookupCharacters.next},
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev;

          return Object.assign({}, prev, {
            lookupCharactersBySeason:{
              next: fetchMoreResult.lookupCharacters.next,
              previous: fetchMoreResult.lookupCharacters.previous,
              hasNext: fetchMoreResult.lookupCharacters.hasNext,
              hasPrevious: fetchMoreResult.lookupCharacters.next,
              characters: [...prev.lookupCharacters.characters, ...fetchMoreResult.lookupCharacters.characters],
              __typename: fetchMoreResult.lookupCharacters.__typename
            }
          });
        }
      })
    }
  }*/

  const fetchMoreRecords = async (next: boolean = true)=>{
    if(((next && (isInitial || hasNextCursor)) || (!next && (hasPreviousCursor))) && !loading){
      let variables:LeaderboardFeedVars = {classes:selectedClasses,ranked:ranked,season:season,byUser:byUser,server:server,startDate:startDate,endDate:endDate};
      if(next){
        variables.next = isInitial ? data?.leaderboardFeed.next : nextCursor;
      }else{
        variables.previous = previousCursor;
      }
        
      let fetchMoreResult = await fetchMore({
        variables:variables,
        updateQuery: (prev, {fetchMoreResult}) => {
          if (!fetchMoreResult) return prev;
          let players = [...prev?.leaderboardFeed?.players || [], ...fetchMoreResult.leaderboardFeed.players];
          players = _.sortBy(players,(character)=>character.ranking);
          players = _.uniqBy(players,(character)=>character._id);

          if(next)
            setScrollToIndex(undefined);
          
          
          return Object.assign({}, prev, {
            leaderboardFeed:{
              next: fetchMoreResult.leaderboardFeed.next,
              previous: fetchMoreResult.leaderboardFeed.previous,
              hasNext: fetchMoreResult.leaderboardFeed.hasNext,
              hasPrevious: fetchMoreResult.leaderboardFeed.hasPrevious,
              players: players,
              __typename: fetchMoreResult.leaderboardFeed.__typename
            }
          });
        }
      })

      setIsInitial(false);

      if(fetchMoreResult.data){
        if(!next){
          setNewLength(fetchMoreResult.data.leaderboardFeed.players.length + (data?.leaderboardFeed?.players?.length || 0));
          setPreviousCursor(fetchMoreResult.data.leaderboardFeed.previous);
          setHasPreviousCursor(fetchMoreResult.data.leaderboardFeed.hasPrevious);
        }else{
          setNewLength(0);
          setNextCursor(fetchMoreResult.data.leaderboardFeed.next);
          setHasNextCursor(fetchMoreResult.data.leaderboardFeed.hasNext)
        }
      }
    }
  }

  useEffect(()=>{
    if(!reseting && shouldRefetch && isMounted()){
      if (typingTimeout) clearTimeout(typingTimeout);
      setTypingTimeout(
        setTimeout(async () => {
          let refetchResult = await refetch({previous: "", next:"", classes:selectedClasses, season:season, ranked:ranked,server:server,byUser:byUser,startDate:startDate,endDate:endDate})
          if(refetchResult.data){
            setIsInitial(false);
            setPreviousCursor(refetchResult.data.leaderboardFeed.previous);
            setHasPreviousCursor(refetchResult.data.leaderboardFeed.previous != null);
            setNextCursor(refetchResult.data.leaderboardFeed.next);
            setHasNextCursor(refetchResult.data.leaderboardFeed.hasNext)
          }
          setShouldRefetch(false);
        }, 300)
      );
    }
  },[reseting,selectedClasses,shouldRefetch])

  useEffect(()=>{
    if(data?.leaderboardFeed.players.length == newLength && !isInitial){
      let scrollTo = 30 + startingIndex;
      setScrollToIndex(scrollTo);
    }
  },[data?.leaderboardFeed.players.length, newLength])

  const [showCalendar,setShowCalendar] = useState(false);
  const [anchorEl2, setAnchorEl2] = React.useState<HTMLButtonElement | null>(null);

  const onChangeStartDate = (value: string) => {
    setStartDate(value);
    setShouldRefetch(true);
  }

  const onChangeEndDate = (value: string) => {
    setEndDate(value);
    setShouldRefetch(true);
  }

  const players = data?.leaderboardFeed?.players || [];
  const seasonLabel = (s: ISeason) => `${s.label} (${moment(s.start,"YYYY-MM-DD").format("MMM Do YYYY")} - ${moment(s.end,"YYYY-MM-DD").format("MMM Do YYYY")})`;
  const filtered = selectedClasses.length > 0 || startDate != null || endDate != null;

  return (
		<Grid container spacing={2} className="content-container">
      <Grid item xs={12}>
        <PageHeader
          title="Leaderboard"
          subtitle={`Matchmaking ratings${season == 0 ? ' across all seasons' : ' for the selected season'}.`}
          icon={<EmojiEvents />}
          actions={players.length > 0 ? <span className={classes.count}>Showing <strong>{players.length}</strong></span> : undefined}
          childrenStyle="filters"
        >
          <div className={page.filters}>
            <TextField select size="small" variant="outlined" label="Server" value={server} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setServer(event.target.value as string); setShouldRefetch(true); }}>
              <MenuItem value={`Fury`}>Fury</MenuItem>
              <MenuItem value={`Crom`}>Crom</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Leaderboard" value={byUser === true ? 1 : 0} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setByUser((event.target.value as any) == 1); setShouldRefetch(true); }}>
              <MenuItem value={0}>Characters</MenuItem>
              <MenuItem value={1}>Players</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Queue" value={ranked === true ? 1 : 0} className={clsx(classes.filterField, classes.filter)}
              onChange={(event) => { setRanked((event.target.value as any) == 1); setShouldRefetch(true); }}>
              <MenuItem value={1}>Ranked</MenuItem>
              <MenuItem value={0}>3v3/2v2</MenuItem>
            </TextField>
            <TextField select size="small" variant="outlined" label="Season" value={season} className={clsx(classes.filterField, classes.filterWide)}
              onChange={(event) => { setSeason(Number(event.target.value)); setShouldRefetch(true); }}
              SelectProps={{renderValue: (selected: any) => {
                let found = seasons.find((s)=>s.season == selected);
                return selected == 0 ? 'All Time' : found ? seasonLabel(found) : "Season not found.";
              }}}>
              <MenuItem value={0}>All Time</MenuItem>
              {seasons.map((s) => <MenuItem key={s.season} value={s.season}>{seasonLabel(s)}</MenuItem>)}
            </TextField>
            <TextField select size="small" variant="outlined" label="Classes" value={selectedClasses} className={clsx(classes.filterField, classes.filterWide)}
              onChange={(event) => { setSelectedClasses(event.target.value as any as string[]); setShouldRefetch(true); }}
              SelectProps={{
                multiple: true,
                displayEmpty: true,
                renderValue: (selected: any) => (selected as string[]).length == 0
                  ? <span className={page.muted}>All classes</span>
                  : <span className={classes.selectedClasses}>{(selected as string[]).map((c) => <img key={c} src={classImages.getColorIcon(c as AocClasses)} title={c} />)}</span>,
              }}
              InputLabelProps={{shrink: true}}>
              {[AocClasses.Assassin,AocClasses.Barbarian,AocClasses.Ranger,
                AocClasses.BearShaman,AocClasses.TempestofSet,AocClasses.PriestofMitra,
                AocClasses.Demonologist,AocClasses.Necromancer,AocClasses.HeraldofXotli,
                AocClasses.Guardian,AocClasses.Conqueror,AocClasses.DarkTemplar].map((_class) => {
                  let hasClass = selectedClasses.indexOf(_class) > -1;
                return (
                  <MenuItem key={_class} value={_class}>
                    <Checkbox size="small" checked={hasClass} />
                    <img className={classes.classOption} src={classImages.getColorIcon(_class)} title={_class} />
                    <ListItemText primary={_class} />
                  </MenuItem>
                )
              })}
            </TextField>
            <Button startIcon={<CalendarToday fontSize="small" />} className={clsx(classes.dateButton, {[classes.dateActive]: startDate != null})}
              onClick={(event)=>{setAnchorEl2(event.currentTarget); setShowCalendar(true);}}>
              {startDate ? `${moment(startDate).format("MMM Do, YYYY")}${endDate ? ` - ${moment(endDate).format("MMM Do, YYYY")}` : ''}` : 'Any date'}
            </Button>
            <Button className={classes.resetButton} disabled={!filtered} onClick={()=>resetClasses()}>Reset filters</Button>
          </div>
        </PageHeader>
        <Popover
          id={'simple-popover'}
          open={showCalendar}
          anchorEl={anchorEl2}
          onClose={()=>{setShowCalendar(false)}}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
        >
          <DateRangePicker
            ranges={[{startDate:startDate && startDate ? moment(startDate).toDate() : new Date(),endDate:endDate && endDate ? moment(endDate).toDate() : new Date(),key: 'selection'}]}
            onChange={(ranges: any)=>{
              let start = moment(ranges.selection.startDate).toISOString();
              let end = moment(ranges.selection.endDate).toISOString();
              onChangeStartDate(start);
              onChangeEndDate(end);
            }}
          />
        </Popover>
      </Grid>
			<Grid item xs={12}>
        <div className={clsx(page.tablePanel, classes.table)} style={{overflowX: 'auto'}}>
          {loading && <LinearProgress style={{position: 'absolute', top: 0, left: 0, right: 0, height: 2, zIndex: 2}} />}
          <div style={{ height: 'calc(97vh - 300px)', minHeight: 360, width: '100%', minWidth:'1215px'}}>
            <VirtualizedTable
              reference={gridRef}
              rowHeight={58}
              headerHeight={40}
              rowCount={players.length}
              rowGetter={({ index }) => players[index]}
              scrollToIndex={scrollToIndex}
              onRowsRendered={({startIndex}:any)=>{
                setStartingIndex(startIndex);
              }}
              customCellRenderer={({columnIndex,rowIndex,cellData,rowData})=>{
                const winRate = rowData.wins + rowData.loses > 0 ? (rowData.wins / (rowData.wins + rowData.loses)) * 100 : 0;
                const characterClass = rowData.character?.class as AocClasses;
                return (<React.Fragment>
                  {columnIndex == 0 ?
                    <span className={classes.rank} style={RANK_STYLES[cellData] || undefined}>{cellData}</span>
                  : columnIndex == 1 ?
                    // class icon (or avatar), name and a secondary line
                    <div className={classes.player}>
                      <img className={clsx(classes.playerIcon, {[classes.playerAvatar]: byUser})}
                        src={byUser ? rowData.user?.avatar || PlaceHolderImage : classImages.getColorIcon(characterClass)} title={byUser ? cellData : characterClass} />
                      <div style={{minWidth: 0}}>
                        <NavLink to={byUser ? `/users/${rowData._id}` : `/characters/${rowData._id}`} className={clsx(page.link, classes.playerName)}>{cellData}</NavLink>
                        <div className={classes.playerSub}>{byUser ? `${rowData.wins + rowData.loses} matches` : characterClass}</div>
                      </div>
                    </div>
                  : columnIndex == 2 ?
                    <span className={classes.mmr}>{cellData}</span>
                  : columnIndex == 3 ?
                    <span className={classes.perf}>{getRatingComponent(rowData.rating)}</span>
                  : columnIndex == 4 ?
                    <div className={classes.winRate}>
                      <div className={classes.winTop}>
                        <span className={classes.winPct} style={{color: winRateColor(winRate)}}>{`${Math.round(winRate)}%`}</span>
                        <span className={classes.winRecord}>{`${rowData.wins}W ${rowData.loses}L`}</span>
                      </div>
                      <div className={classes.winTrack}>
                        <div className={classes.winFill} style={{width: `${winRate}%`, background: winRateColor(winRate)}} />
                      </div>
                    </div>
                  : columnIndex == 5 || columnIndex == 6 ?
                    <span className={classes.dim}>{cellData}</span>
                  : columnIndex == 7 ?
                    <span className={classes.perf}>{getRatingComponent(rowData.avgrating)}</span>
                  : columnIndex == 8 ?
                    <span className={classes.perf}>{getRatingComponent(rowData.maxrating)}</span>
                  : columnIndex == 9 ?
                    <span className={classes.perf}>{getRatingComponent(rowData.minrating)}</span>
                  : columnIndex == 10 && typeof cellData == 'number' ?
                    <span className={classes.change} style={changeStyle(cellData)}>{cellData > 0 ? `+${cellData}` : cellData}</span>
                  :
                    cellData
                  }
                  {(columnIndex == 0 && rowIndex == players.length - 3) &&
                    <Waypoint
                      onEnter={async ()=>{
                        await fetchMoreRecords();
                      }}
                    />
                  }
                </React.Fragment>)
              }}
              columns={[
                {
                  width: 70,
                  label: 'Rank',
                  dataKey: 'ranking'
                },
                {
                  width: 240,
                  label: byUser ? 'Player' : 'Character',
                  dataKey: byUser ? 'user.displayname' : 'character.name',
                },
                {
                  width: 90,
                  label: 'Mmr',
                  dataKey: byUser ? 'ummr' : 'mmr',
                  numeric: true,
                },
                {
                  width: 80,
                  label: 'Perf.',
                  dataKey: 'rating',
                  numeric: true,
                },
                {
                  width: 200,
                  label: 'Win Rate',
                  dataKey: 'wins'
                },
                {
                  width: 85,
                  label: '▲ Mmr',
                  dataKey: byUser ? 'maxummr' : 'maxmmr',
                  numeric: true,
                },
                {
                  width: 85,
                  label: '▼ Mmr',
                  dataKey: byUser ? 'minummr' : 'minmmr',
                  numeric: true,
                },
                {
                  width: 95,
                  label: 'Avg Perf.',
                  dataKey: 'avgrating',
                  numeric: true,
                },
                {
                  width: 85,
                  label: '▲ Perf.',
                  dataKey: 'maxrating',
                  numeric: true,
                },
                {
                  width: 85,
                  label: '▼ Perf.',
                  dataKey: 'minrating',
                  numeric: true,
                },
                {
                  width: 100,
                  label: 'Mmr Change',
                  dataKey: 'mmrChange',
                  numeric: true,
                }
              ]}
              data={players}
            />
          </div>
          {!loading && players.length == 0 &&
            <div style={{position: 'absolute', top: 40, left: 0, right: 0}}>
              <PageEmpty icon={<EmojiEvents />}
                title={filtered ? 'No matches for these filters' : 'No rankings yet'}
                text={`No players on this leaderboard${filtered ? ' with these filters' : ''} yet.${filtered ? ' Try another class, season or date range.' : ' Rankings appear once matches are played.'}`}
                action={filtered ? <Button className={page.secondaryButton} onClick={()=>resetClasses()}>Reset filters</Button> : undefined} />
            </div>
          }
        </div>
			</Grid>
		</Grid>
	);
};


{/*
      <Grid item xs={3}>
        <SearchBar onChange={onChangeName} onFocus={(e)=>{
          setAnchorEl(e.target);
          setShowCharacterSearch(true)
        }} onBlur={(e)=>{
          setTimeout(()=>{
            setShowCharacterSearch(false)
            setAnchorEl(null);
          },500)
        }} value={name} placeholder={"Search the leaderboard..."} />
        
        <Popper placement="bottom-start" open={showCharacterSearch} anchorEl={anchorEl}>
          <Paper className={classes.characterContainer}>
            <ul className="add-player-list" style={{height:'25em',overflow:'auto'}} ref={scrollableAncestor}>
              {
                lookupData && 
                  <React.Fragment>
                    {lookupData.lookupCharacters.characters.map((character,index)=>{
                      let characterClass = (character && character.class) ? character.class : "";
                      return <li key={character._id.toString()} className="add-player-item noselect" onClick={()=>{
                        onCharacterSelect(character._id.toString());
                        setShowCharacterSearch(false);
                      }}>
                        <img className="add-player-icon" src={classImages.getColorIcon(characterClass as AocClasses)} title={characterClass} />
                        <div className="add-player-title">{character.name}</div>
                        <div className="add-player-description">{character.class}</div>
                        {index == lookupData.lookupCharacters.characters.length - 3 &&
                          <Waypoint
                            scrollableAncestor={scrollableAncestor.current}
                            onEnter={()=>{
                              fetchMoreCharacters();
                            }}
                        />}
                      </li>
                    })}
                  </React.Fragment>
              }
            </ul>
          </Paper>
        </Popper>
      </Grid>
      */}